const coursetemplates = {
	title: "Course templates",
	stitle: "Course template",
	new_coursetemplate: "New Course Template",
	edit_coursetemplate: "Edit Course Template: {name}",
	view_coursetemplate: "View Course Template: {name}",
	list_title: "List of Course Templates",
	list_subtitle: "Manage Course Templates",
	create_title: "Create New Course Template",
	update_title: "Update Course Template",
	address_title: "Address",
	details_title: "Course Template Details",
	id: "ID",
	name: "Name",
	short_description: "Practical info for registration form",
	long_description: "Expertise description ( Visible on enrollemnt form too)",
	certificate_display_name: "Certificate display name",
	coursetemplatetype_id: "Type",
	pdf_template: "PDF Template",
	pdf_title: "PDF Title",
	pdf_description: "PDF Description",
	pdf_content: "PDF Content",
	info_link: "Info Link",
	type: "Type",
	price: "Price",
	price_proof: "Price Proof",
	price_vat: "Price VAT",
	valid_for: "Valid for",
	status: "Status",
	created_by: "Created By",
	number_of_days: "Number of Days",
	send_email_notification: "Email notification",
	send_sms_notification: "SMS notification",
	duplicate_message: "Do you want to create a copy of the template?",
	enrolment_preview: "Enrolment Preview",
	internal_comment: "Internal Comment",
	upload_pdf_template: "Upload template",
	select_pdf_template: "Select PDF",
	preview_pdf_template: "PDF Preview",
	months: "months",
	valid_for_helptext: "Leave blank for no expiration date, otherwise expiration date will be calculated from the issue date.",
	available_course_templates: "Available course templates",
	import_success: "Course template(s) successfully imported.",
	import_failed: "Failed to import course template(s),",
	proceed_template_editing: "Would you like to proceed with template editing?",
	module_template_used_multiple: "Module template is used in the following course templates",
	updated: "Updated",
	copied_from_admin: "Copied from admin template on {datetime} by {name}",
	admin_template_from: "Admin template is from {datetime}",
	admin_version: "Admin version",
	select_template_type: "Please select type of the course template (Cannot be changed!)",
	type_normal_helptext: "Course template for a course with stat and end dates. It includes prices. Used in commercial learning. For example for certified learning",
	type_long_helptext: "Template for learning without start/end date. For example used in high schools and in company internal learning.",
	klarna_checkout: "Klarna Checkout",
	klarna_checkout_type: "Select Klarna Checkout",
	klarna_checkout_type_helptext: "Check this box if you would like to activate the payment with Klarna",
	enrolment_due_in_days: "Enrollment due in days",
	enrolment_due_in_days_helptext: "Enter value of days for the calculation of the enrollment due date.",
};
export default coursetemplates;